import { avatarTone, initialsOf } from '../../../common/libs/initials';
import { useProjectTeams } from '../contexts/projects';

import '../../teams/styles/members.css';

// Who works on this project. READ ONLY on purpose: assigning a team to a
// project is /admin/project-teams, which carries its own rules — a scope per
// repository and per tier — and belongs in its own section, not in a corner of
// the project form.
//
// The answer can bring SEVERAL teams and that is not an error: they arrive
// ordered by which one has the most active work here.

export default function ProjectTeams({ projectId }) {
    const { data, isLoading, error } = useProjectTeams(projectId);

    if (isLoading) return <p className="members__loading">Cargando equipos...</p>;

    if (error) {
        return (
            <p className="members__error">
                {error.message || 'No se pudieron cargar los equipos'}
            </p>
        );
    }

    // The response shape is not published. Both readings are tried instead of
    // assuming one, the same way the project detail is read.
    const teams = data?.teams ?? (Array.isArray(data) ? data : []);

    return (
        <section className="members">
            <header className="members__header">
                <h3 className="members__title">Quién trabaja acá</h3>
                <span className="members__count">{teams.length}</span>
            </header>

            {!teams.length && (
                <p className="members__empty">
                    Todavía no hay equipos asignados a este proyecto.
                </p>
            )}

            {teams.map(entry => {
                const team = entry.team ?? entry;
                const members = entry.members ?? [];

                return (
                    <div className="project-team" key={team.id}>
                        <div className="project-team__head">
                            <span className="project-team__name">{team.name}</span>
                            {/* The scope, which the backend explains in words —
                                which repositories and which tiers this team
                                reaches. A NULL there means "all of them", so the
                                sentence is the one thing that must not be
                                summarised into a number. */}
                            {entry.scope && (
                                <span className="project-team__scope">{entry.scope}</span>
                            )}
                        </div>

                        {!members.length
                            ? <p className="members__empty">Este equipo no tiene miembros activos.</p>
                            : (
                                <ul className="members__list">
                                    {members.map(member => (
                                        <li className="member" key={member.id ?? member.user_id}>
                                            <span
                                                className={`avatar member__avatar avatar--tone-${avatarTone(member.user?.name || member.user?.email)}`}
                                                aria-hidden="true"
                                            >
                                                {initialsOf(member.user?.name || member.user?.email)}
                                            </span>
                                            <span className="member__identity">
                                                <span className="member__name">
                                                    {member.user?.name || `Usuario #${member.user_id}`}
                                                </span>
                                                <span className="member__email">{member.user?.email}</span>
                                            </span>
                                            <span className="member__role">{member.team_role}</span>
                                            <span />
                                        </li>
                                    ))}
                                </ul>
                            )}
                    </div>
                );
            })}
        </section>
    );
}
